import {X509Certificate} from '@peculiar/x509';

export type CertificateMetadata = {
    validFrom: Date,
    validTo: Date,
    subject: string,
    issuer: string,
};

function extractCommonName(distinguishedName: string): string {
    const cnMatch = distinguishedName.match(/CN=([^,]+)/);
    if (cnMatch) {
        return cnMatch[1].trim();
    }
    const oMatch = distinguishedName.match(/O=([^,]+)/);
    if (oMatch) {
        return oMatch[1].trim();
    }
    return distinguishedName;
}

export function parseCertificateMetadata(pem: string): CertificateMetadata | null {
    try {
        const cert = new X509Certificate(pem);
        return {
            validFrom: cert.notBefore,
            validTo: cert.notAfter,
            subject: extractCommonName(cert.subject),
            issuer: extractCommonName(cert.issuer),
        };
    } catch {
        return null;
    }
}

export function formatCertificateDate(date: Date): string {
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
}

export function formatValidityRange(metadata: CertificateMetadata): string {
    return `${formatCertificateDate(metadata.validFrom)} — ${formatCertificateDate(metadata.validTo)}`;
}
